<!-- onselectstart="return false" -->
<template>
  <div id="app">
  <router-view />
  </div>
</template>

<script>
  export default {
      name: 'App',
  data(){
    return {

    }
  },
  methods: {

  },
  created(){
    console.log(process.env,'process.env')
  }
  }
</script>

<style>
  body {
      font-size: 16px;
      background-color: #f8f8f8;
      -webkit-font-smoothing: antialiased;
  }
/* 滚动条样式 */
/* ::-webkit-scrollbar {display:none} */
::-webkit-scrollbar {
    width: 5px;
    height: 5px
}

::-webkit-scrollbar-track {
    border-radius: 10px;
    width: 10px
}

::-webkit-scrollbar-thumb {
    border-radius: 2px;
    background: rgba(0, 0, 0, 0.1);
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1)
}

::-webkit-scrollbar-thumb:window-inactive {
    background: rgba(0, 0, 0, 0.1);
}
.zzy_zk{background:#fafafa;padding:8px 15px; border:1px solid #e5e5e5; border-radius:5px; line-height:20px; min-height:20px;}
/* 滚动条样式结束 */
  .v-modal{
    z-index: 0 !important;
  }
</style>
